import {
  EContractorPaymentType,
  paymentItemFormSchema,
} from "../contractor-payments";
import { schemes, zSchema } from "../schema-validation";
import { ETxnSpeed } from "../transaction-speeds";
import { EDisbursementMethod } from "../workers-shared";

// Common fields for both legacy and new flows
const commonContractorPaymentFields = {
  approval_required: zSchema.boolean().default(false),
  companyID: schemes.companyID(),
  contractorID: schemes.mongoObjectId(),
  disbursement: zSchema
    .object({
      method: zSchema.nativeEnum(EDisbursementMethod),
    })
    .optional(),
  pay_date: schemes.isoDate("Invalid pay date"),
  speed: zSchema.nativeEnum(ETxnSpeed).default(ETxnSpeed.TWO_DAY),
  type: zSchema
    .enum([
      EContractorPaymentType.REGULAR,
      EContractorPaymentType.REIMBURSEMENT,
      EContractorPaymentType.KIT,
      EContractorPaymentType.ALL,
    ] as const)
    .default(EContractorPaymentType.ALL),
  customerAccountID: schemes.uuid().optional(),
};

// Legacy schema - with amount field (for backward compatibility)
export const createContractorPaymentSchema = zSchema.object({
  ...commonContractorPaymentFields,
  amount: zSchema.string().refine(
    (val) => {
      const num = parseFloat(val);
      return !Number.isNaN(num) && num > 0;
    },
    {
      message: "Amount must be greater than 0",
    }
  ),
});

// Standard schema - with payment_items (amount calculated automatically)
export const createContractorPaymentWithItemsSchema = zSchema.object({
  ...commonContractorPaymentFields,
  payment_items: zSchema
    .array(paymentItemFormSchema)
    .min(1, "At least one payment item is required"),
  apply_contractor_deductions: zSchema.boolean().optional(),
  contractor_deduction_template_ids: zSchema.array(zSchema.string()).optional(),
});
